import { useMemo } from 'react'

import { REASON_THRESHOLD } from '../../../constants'
import { addressShortener } from '../../../helpers'
import useDclProfiles from '../../../hooks/useDclProfiles'
import useFormatMessage from '../../../hooks/useFormatMessage'
import { VoteByAddress } from '../../../types/votes'
import { isSameAddress } from '../../../utils/snapshot'
import { formatChoice } from '../../../utils/votes/utils'
import Comment from '../../Comments/Comment'
import Section from '../View/Section'

interface Props {
  votes?: VoteByAddress
  isLoadingVotes?: boolean
  choices: string[]
}

function VotingRationaleSection({ votes, isLoadingVotes, choices }: Props) {
  const t = useFormatMessage()
  const votesWithRationale = useMemo(
    () =>
      votes
        ? // eslint-disable-next-line @typescript-eslint/no-unused-vars
          Object.fromEntries(Object.entries(votes).filter(([_, vote]) => !!vote.reason && vote.vp >= REASON_THRESHOLD))
        : undefined,
    [votes]
  )
  const showSection = votesWithRationale && Object.keys(votesWithRationale).length > 0
  const { profiles, isLoadingProfiles } = useDclProfiles(Object.keys(votesWithRationale || {}))
  return (
    <>
      {showSection && !isLoadingProfiles && (
        <Section isLoading={isLoadingVotes} title={t('page.rationale.title')} isNew>
          {Object.entries(votesWithRationale).map(([address, vote]) => {
            const profile = profiles.find((profile) => isSameAddress(profile.address, address))!
            return (
              <Comment
                key={address}
                cooked={vote.reason}
                forumUsername={profile.username || addressShortener(address)}
                createdAt={new Date(vote.timestamp * 1000).toISOString()}
                avatarUrl={profile.avatarUrl}
                address={address}
                extraInfo={{
                  choice: formatChoice(choices[vote.choice - 1]),
                  vp: vote.vp,
                }}
              />
            )
          })}
        </Section>
      )}
    </>
  )
}

export default VotingRationaleSection
